import { currencyConversion } from './helpers.js'

export const pieChartOptionsVar = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    datalabels: false,
    legend: {
      position: 'bottom',
      align: 'center',
      labels: {
        generateLabels: (chart) => {
          const datasets = chart.data.datasets
          return datasets[0].data.map((data, i) => ({
            text: `${chart.data.labels[i]} ${currencyConversion(data)}`,
            fillStyle: datasets[0].backgroundColor[i],
            strokeStyle: datasets[0].borderColor[i]
          }))
        },
        textAlign: 'center'
      },
      title: {
        display: true,
        padding: 10,
        text: ''
      }
    },
    title: {
      display: false
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          let label = context.dataset.label || ''

          if (label) {
            label += ': '
          }
          if (context.parsed !== null) {
            label += currencyConversion(context.parsed)
          }
          return label
        }
      }
    }
  }
}
